"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { CalendarDays } from "lucide-react";
export default function BookATable() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="223017" id="ready-for-your-reveal" className="relative w-full py-24 lg:py-32 overflow-hidden flex items-center justify-center min-h-[60vh] bg-background text-foreground">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/luxury_wood_grain_texture.png)] blur-sm scale-105 opacity-40" aria-hidden="true" />
      <div className="absolute inset-0 bg-primary/90" aria-hidden="true" />

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold text-primary-foreground mb-10 tracking-tighter drop-shadow-xl max-w-4xl">
          Inspired by what you see? Let’s design your version.
        </h2>

        <div className="relative inline-flex group mt-2">
          {}
          <div className="absolute inset-0 rounded-md bg-secondary animate-ping opacity-20 duration-1000"></div>
          
          <Button asChild size="lg" className="relative h-16 px-10 rounded-md text-lg md:text-xl font-default font-semibold shadow-2xl transition-transform group-hover:scale-105 bg-secondary text-secondary-foreground hover:bg-secondary/90">
            <Link to="/StartYourProjectPage">
              <CalendarDays className="mr-2 size-6" />
              Start Your Project
            </Link>
          </Button>
        </div>

        <p className="mt-8 text-primary-foreground/80 font-default font-medium text-lg md:text-xl drop-shadow-sm">
          Licensed & Insured Craftsmen Serving the Denver Metro Area
        </p>
      </div>
    </section>;
}